import script from "./OpenMiniProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenMiniProgram.vue?vue&type=script&setup=true&lang=js"

import "./OpenMiniProgram.vue?vue&type=style&index=0&id=4865a196&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4865a196"]])

export default __exports__